import {IWuAppHeaderAccount} from '@/components/appHeader/types/WuAppHeaderAccount'
import {cn} from '@/lib/utils'

export const SettingsMenuItem: React.FC<{
  settings: IWuAppHeaderAccount['settings']
  dir?: 'ltr' | 'rtl'
}> = ({settings, dir}) => (
  <>
    <hr className="border-gray-subtle" />
    <section className="relative flex items-center justify-start gap-2">
      <span
        className={cn(
          'absolute wm-settings text-base',
          dir === 'rtl' ? 'right-4' : 'left-4',
        )}
      ></span>
      <ul className="w-full" dir={dir}>
        {settings?.map(item => (
          <li key={item.title} tabIndex={-1} dir={dir}>
            <a
              href={item.url}
              className={cn(
                'inline-block w-full py-2 hover:bg-gray-20 focus-within:bg-gray-20 focus:outline-none',
                dir === 'rtl' ? 'pr-14 text-right' : 'pl-14',
              )}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </section>
    <hr className="border-gray-subtle" />
  </>
)
